import { Toaster as Sonner } from 'sonner';

export { toast } from 'sonner';

/** @param {import('react').ComponentProps<typeof Sonner>} props */
export function Toaster(props) {
  return (
    <Sonner
      position="top-right"
      closeButton
      richColors
      toastOptions={{ classNames: { toast: 'font-sans text-sm' } }}
      style={{
        '--normal-bg': 'var(--popover)',
        '--normal-text': 'var(--popover-foreground)',
        '--normal-border': 'var(--border)',
      }}
      {...props}
    />
  );
}
